var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styles from './Styles.module.scss';
import ShowPassword from '../../assets/eye-fill.svg';
import HidePassword from '../../assets/eye-slash-fill.svg';
import { useForm } from "react-hook-form";
import { profileAPI } from "../../API/api";
import Preloader from '../../assets/preloader.svg';
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
const TEXT = 'text';
const PASSWORD = 'password';
const DeleteUserForm = ({}) => {
    const [typeInput, setTypeInput] = useState(PASSWORD);
    const { t } = useTypedTranslation();
    const { register, handleSubmit, formState: { errors, isSubmitting }, setError } = useForm({
        mode: 'onSubmit'
    });
    const handleClick = () => {
        typeInput === PASSWORD ? setTypeInput(TEXT) : setTypeInput(PASSWORD);
    };
    const submit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        profileAPI.deleteUserAndData(data.password)
            .catch(err => {
            console.log(err);
            setError('password', { message: t('form.incorrectPassword') });
        });
    });
    return (_jsx("div", { className: styles.group, style: { padding: '16px 8px' }, children: _jsxs("form", { onSubmit: handleSubmit(submit), children: [_jsxs("div", { className: styles.passwordInput, children: [_jsx("input", Object.assign({ type: typeInput, placeholder: t('form.password'), maxLength: 20, autoFocus: true }, register('password', { required: { value: true, message: t('form.required') } }))), typeInput === PASSWORD && _jsx(ShowPassword, { onClick: handleClick }), typeInput === TEXT && _jsx(HidePassword, { onClick: handleClick })] }), _jsx("div", { className: styles.error, children: errors.password && _jsx("span", { children: errors.password.message }) }), _jsx("button", { disabled: isSubmitting, children: !isSubmitting ? t('deleteAccount') : _jsx(Preloader, {}) })] }) }));
};
export default DeleteUserForm;
